export function OutlinePlusIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 12C21 13.1 20.1 14 19 14H14V19C14 20.1 13.1 21 12 21C10.9 21 10 20.1 10 19V14H5C3.9 14 3 13.1 3 12C3 10.9 3.9 10 5 10H10V5C10 3.9 10.9 3 12 3C13.1 3 14 3.9 14 5V10H19C20.1 10 21 10.9 21 12Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
